import type { ReactNode } from 'react'

import clsx from 'clsx'

import s from './styles.module.scss'

export interface BaseOption {
  id: string | number
}

interface OptionsListProps<T extends BaseOption> {
  options: T[]
  renderContent: (option: T) => ReactNode
  renderControl?: (option: T) => ReactNode
  className?: string
  onOptionClick?: (option: T) => void
}

export const OptionsList = <T extends BaseOption>({
  options,
  renderContent,
  renderControl,
  className,
  onOptionClick,
}: OptionsListProps<T>) => {
  return (
    <div className={clsx(s.list, className)}>
      {options.map((option) => {
        const RowComponent = onOptionClick ? 'button' : 'div'

        return (
          <RowComponent
            key={option.id}
            className={clsx(onOptionClick ? s.rowButton : s.row)}
            {...(onOptionClick
              ? {
                  type: 'button',
                  onClick: () => onOptionClick(option),
                }
              : {})}
          >
            <div className={s.info}>{renderContent(option)}</div>
            {renderControl?.(option)}
          </RowComponent>
        )
      })}
    </div>
  )
}
